export default __webpack_public_path__ + "static/media/alert_your_plan.bd1325db.png";